import { Injectable } from '@angular/core';
import { FilterService } from './filter.service';
import { Observable } from 'rxjs';
import { PanelsService } from '../../layout/services/panels.service';
import { FilterPanelComponent } from '../components/filter-panel/filter-panel.component';

@Injectable()
export class FilterPanelService {
  constructor(private panelHandler: PanelsService) { }

  public togglePanel(show: boolean, payload?: any, componentToLoad = FilterPanelComponent): Observable<any> {
    if (show) {
        return this.panelHandler.showLayout(componentToLoad, { payload}, FilterService.FilterPanelName);
    } else {
        this.panelHandler.dismissObservable(FilterService.FilterPanelName);
        return Observable.empty();
    }
  }
}
